import jsTemplates from "refractor/js-templates";
export default jsTemplates;